import { USER_TYPE } from "utils/dataCenter";
import * as apis from "../../apis";
import {
  Headquarter,
  Company,
  User,
  set_company,
  set_shop,
  set_user,
  set_headquarter,
  Shop,
} from "../../redux/slices/auth";
import { getPhoneNumberString } from "../../utils/regexUtil";
import { dispatch } from "../../redux/store";
import { API_ERROR_CODE } from "apis/utils/dataCenter";

//
function getSortedObjsByStatus(objs: any[], type: string) {
  const temp = [...objs];

  return temp
    .map((a: any) => {
      const status = a[type + "_STATUS"];
      if (status != 0) {
        a.NAME = "(해지)" + a.NAME;
      }
      return a;
    })
    .sort(function (a: any, b: any) {
      const a_status = a[type + "_STATUS"];
      const b_status = b[type + "_STATUS"];
      let x = a.NAME.toLowerCase();
      let y = b.NAME.toLowerCase();
      if (
        (a_status != 0 && b_status != 0) ||
        (a_status == 0 && b_status == 0)
      ) {
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      } else {
        if (a_status != 0) {
          return 1;
        } else {
          return -1;
        }
      }
    });
}

function getHeadquarterObj(companyObjs: Company[], userObj: User) {
  const headquarterObj: Headquarter = {
    NAME: "",
    companyObjs: [],
    HEADQUARTER_AUTH: "1",
  };
  try {
    const { NAME, USER_AUTH } = userObj;
    headquarterObj.NAME = NAME;
    const sortedCompanyObjs = getSortedObjsByStatus(companyObjs, "COMPANY");
    for (const companyObj of sortedCompanyObjs) {
      const { shopObjs } = companyObj;
      if (USER_AUTH != null) {
        companyObj.COMPANY_AUTH = USER_AUTH;
        headquarterObj.HEADQUARTER_AUTH = USER_AUTH;
      } else {
        if (headquarterObj.HEADQUARTER_AUTH < companyObj.COMPANY_AUTH) {
          headquarterObj.HEADQUARTER_AUTH = companyObj.COMPANY_AUTH;
        }
      }

      const sortedShopObjs = getSortedObjsByStatus(shopObjs, "SHOP");
      if (USER_AUTH != null) {
        for (const shopObj of sortedShopObjs) {
          shopObj.SHOP_AUTH = USER_AUTH;
        }
      }
      headquarterObj.companyObjs.push({
        ...companyObj,
        shopObjs: sortedShopObjs,
      });
    }
  } catch (e) {
    console.log("getHeadquarterObj error : ", e);
  }
  return headquarterObj;
}

function getBrandObj(companyObj: Company, shopObjs: Shop[], userObj: User) {
  const { USER_AUTH } = userObj;
  const sortedShopObjs = getSortedObjsByStatus(shopObjs, "SHOP");
  if (USER_AUTH != null) {
    companyObj.COMPANY_AUTH = USER_AUTH;
    for (const shopObj of sortedShopObjs) {
      shopObj.SHOP_AUTH = USER_AUTH;
    }
  }
  return { ...companyObj, shopObjs: sortedShopObjs };
}

export function goVerifyPhoneNumber() {
  dispatch(set_user({ TYPE: "VERIFY_PHONE_NUMBER" }));
}

export function loginProcess(user: any) {
  return new Promise(async (resolve, reject) => {
    try {
      const USER_ID: string = user.username;
      let userData = null;
      const res: any = await apis.user.getUserInfos(USER_ID);
      if (res != null && res.data != null) {
        const { userObj, companyObj, shopObj, companyObjs, shopObjs } =
          res.data;
        userData = userObj;
        switch (userObj.USER_TYPE) {
          case USER_TYPE.HEADQUARTER:
            const headquarterObj = getHeadquarterObj(companyObjs, userObj);
            dispatch(set_headquarter(headquarterObj));
            break;
          case USER_TYPE.HEAD:
          case USER_TYPE.MANAGER:
            const brandObj = getBrandObj(companyObj, shopObjs, userObj);
            dispatch(set_company(brandObj));
            break;
          case USER_TYPE.SHOP:
            if (userObj != null && userObj.USER_AUTH != null) {
              shopObj.SHOP_AUTH = userObj.USER_AUTH;
            }
            if (userObj != null && userObj.PLUG_IN_MA != null) {
              shopObj.PLUG_IN_MA = userObj.PLUG_IN_MA;
            }
            dispatch(set_shop(shopObj));
            break;
          default:
            resolve(null);
            return;
        }
      }
      dispatch(set_user(userData));
      resolve(userData);
    } catch (e) {
      reject(e);
    }
  });
}
